var React = require('react');

function BrandArrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .f73cd843-5627-4bd4-b1bb-f2b03ca8ef90 {\n        fill: #6300ff;\n      }\n    ")),React.createElement("path",{"id":"f40000a7-9902-490c-9749-6dd9ab1d8362","data-name":"Path 47","className":"f73cd843-5627-4bd4-b1bb-f2b03ca8ef90","d":"M536.7719,0H0V40.34119A963.61847,963.61847,0,0,1,165.25889,299.98546,1049.81382,1049.81382,0,0,1,247.8047,721.70877,1104.52077,1104.52077,0,0,1,210.369,1014.62361a1009.51136,1009.51136,0,0,1-105.72982,251.03808A907.24466,907.24466,0,0,1,0,1407.29663v46.80964H536.7719L1488.5812,727.0799Z","key":1})]);
}

BrandArrow.defaultProps = {"id":"b9013ecf-0d8d-418f-bd9f-4c3a67ff60a8","data-name":"Layer 1","viewBox":"0 0 1488.5812 1454.10627"};

module.exports = BrandArrow;

BrandArrow.default = BrandArrow;
